import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const ContentDiv = styled.div`
	display: flex;
	flex-direction: row;
`;

const FULL_WIDTH = '100%';

export const SectionWrapper = styled.div`
	height: auto;
	padding: 24px 32px 5px 32px;
	background-color: ${colors.white};
`;

export const ContainerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: ${FULL_WIDTH};
	height: auto;
	background-color: ${colors.white};
	margin-bottom: 32px;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;
